<template>
	<div :class="[{ mobile: mobile }, 'under-construction']">
		<h1>{{ $t('underConstruction') }}</h1>
	</div>
</template>

<script>
import { isMobile } from '@/common/mobile';

export default {
	name: 'UnderConstruction.vue',
	data() {
		return {
			mobile: isMobile(),
		};
	},
};
</script>

<style scoped>
.under-construction h1 {
	/*padding: 200px;*/
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	text-align: center;
}
.under-construction.mobile {
	min-height: calc(100vh - 110px);
}
</style>
